<template>
    <div class="uk-margin uk-overflow-auto">
        <h3 class="uk-margin-remove">{{ $t("Einkaufsliste") }}</h3>

        <table class="uk-table-striped uk-table uk-margin-remove-top cart-table">
            <thead class="uk-text-bold">
                <tr>
                    <td>{{ $t("Anzahl") }}</td>
                    <td>{{ $t("Art") }}</td>
                    <td class="uk-text-right">{{ $t("Preis") }}</td>
                    <td class="uk-text-right">{{ $t("Enthaltene MwSt.") }}</td>
                    <td class="uk-text-right">{{ $t("Total") }}</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(cartItem, ticketId) in selection" :key="ticketId">
                    <td>{{ cartItem.amount }}</td>
                    <td>{{ cartItem.ticket.name }}<span v-if="cartItem.option"> ({{ getOptionName(cartItem) }})</span>
                        <div class="uk-flex uk-text-small summary-included-products" v-if="cartItem.ticket.included_products.length">
                            <span>{{ $t('Beinhaltet') }}:</span>
                            <table>
                                <tr v-for="product in cartItem.ticket.included_products">
                                    <td class="uk-text-right uk-padding-small uk-padding-remove-vertical uk-text-bolder">{{cartItem.amount > 1 ? cartItem.amount+' x ':''}}{{ $filters.currency(product.attributes.price) }}</td>
                                    <td class="uk-padding-remove uk-text-bolder">{{ product.attributes.title }}</td>
                                </tr>
                            </table>
                        </div>
                    </td>

                    <td class="uk-text-right">{{ $filters.currency(cartItem.ticket.price) }}</td>
                    <td class="uk-text-right">{{ $filters.currency(taxCalculate(cartItem)) }} </td>
                    <td class="uk-text-right">{{ $filters.currency(getPrice(ticketId)) }}</td>
                </tr>
                <tr v-if="store.state.couponDiscount">
                    <td class="uk-text-right uk-text-bolder" colspan="4">
                        {{ this.$t('Gutschein') }} "{{ store.state.couponCode }}" <span v-if="couponRelative">({{ store.state.couponValue }}%)</span>
                        <small class="uk-display-block" v-if="store.state.couponOffers.length">{{ $t('Gutschein gilt nur für bestimmte Produkte') }}</small>
                    </td>
                    <td class="uk-text-bolder uk-text-right">
                        -{{ $filters.currency(store.state.couponDiscount) }}
                    </td>
                </tr>
                <tr v-if="store.state.donationSwitch && parseInt(store.state.donationAmount)">
                    <td class="uk-text-right uk-text-bolder" colspan="4">
                        {{ this.$t('Spende') }}
                    </td>
                    <td class="uk-text-bolder uk-text-right">
                        {{ $filters.currency(parseInt(store.state.donationAmount)) }}
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr v-if="store.state.paymentType && paymentTypes[store.state.paymentType].checkoutLabel.length">
                    <td class="uk-text-right uk-text-bolder" colspan="4">
                        {{ $t("Zahlungsweise") }}
                    </td>
                    <td class="uk-text-bolder uk-text-right">
                        {{ $t(paymentTypes[store.state.paymentType].checkoutLabel) }}
                    </td>
                </tr>
                <tr>
                    <td class="uk-text-right uk-text-bolder" colspan="4">
                        {{ $t("Enthaltene MwSt.") }}
                    </td>
                    <td class="uk-text-bolder uk-text-right">
                        {{$filters.currency(sumTaxes) }}
                    </td>
                </tr>
                <tr>
                    <td class="uk-text-right uk-text-bolder uk-text-large" colspan="4">
                        {{ $t("Gesamt") }}
                    </td>
                    <td class="uk-text-bolder uk-text-large uk-text-right uk-text-nowrap">
                        {{ $filters.currency(store.state.total) }}
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
const formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'})
import paymentTypes from "../../forms/paymentTypes.json";
import helper from "../../helper/helper";

export default {
    mixins: [helper],
    props: ['settings'],
    components: {},
    data: () => {
        return {
            selection: {},
            paymentTypes
        }
    },
    mounted() {
        this.selection = this.store.state.selection;
        this.paymentTypes = paymentTypes;
    },
    computed: {
        sumTaxes() {
            let tax = 0;
            Object.keys(this.selection).forEach(id => {
                const cartItem = this.selection[id];
                tax += parseFloat(this.taxCalculate(cartItem));
            })
            return tax;
        },
        couponRelative() {
            return this.store.state.couponType == 'relative'
        }
    },
    methods: {
        taxCalculate(cartItem) {
            const price = this.discountedPrice(cartItem);
            return (price - price / (cartItem.ticket.tax +1)).toFixed(2);
        },
        // Gross price the customer actually pays for this line item, after coupon.
        // VAT must be derived from this, not the list price, otherwise the
        // "included VAT" stays at the full-price amount while the total is discounted.
        discountedPrice(cartItem) {
            const price = cartItem.amount * cartItem.ticket.price;
            const offers = this.store.state.couponOffers;
            const applies = offers.length === 0 || offers.includes(cartItem.ticket.id);
            if (!this.store.state.couponDiscount || !applies) {
                return price;
            }
            if (this.couponRelative) {
                return price - Math.min(price, price * this.store.state.couponValue/100);
            }
            // Absolute coupon: distribute the total discount across all applicable
            // line items proportionally to their gross price.
            let applicableTotal = 0;
            Object.keys(this.selection).forEach(id => {
                const item = this.selection[id];
                if (offers.length === 0 || offers.includes(item.ticket.id)) {
                    applicableTotal += item.amount * item.ticket.price;
                }
            });
            if (applicableTotal <= 0) {
                return price;
            }
            return price - this.store.state.couponDiscount * (price / applicableTotal);
        },
        getPrice(selectionTicketId) {
            const amount = this.selection[selectionTicketId].amount;
            return this.selection[selectionTicketId].ticket.price * amount;
        },
        getOptionName(cartItem) {
            for (let i in cartItem.ticket.options) {
                if (cartItem.ticket.options[i].id == cartItem.option) {
                    return cartItem.ticket.options[i].name
                }
            }
        }
    }
}
</script>
